/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type Day = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday" | "%future added value";
export type ProfileTimeVisualizations_org = {
    readonly calendarTimeStats: {
        readonly calendarId: string | null;
        readonly focusMinutes: number | null;
        readonly busyMinutes: number | null;
        readonly fragmentedMinutes: number | null;
        readonly unclassifiedMinutes: number | null;
        readonly totalMinutes: number | null;
        readonly scoresByDay: ReadonlyArray<{
            readonly calendarId: string | null;
            readonly secondaryKey: string | null;
            readonly busyMinutes: number | null;
            readonly focusMinutes: number | null;
            readonly totalMinutes: number | null;
        } | null> | null;
    } | null;
    readonly userWorkingHours: {
        readonly workingHours: {
            readonly daySettings: ReadonlyArray<{
                readonly day: Day | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "ProfileTimeVisualizations_org";
};
export type ProfileTimeVisualizations_org$data = ProfileTimeVisualizations_org;
export type ProfileTimeVisualizations_org$key = {
    readonly " $data"?: ProfileTimeVisualizations_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProfileTimeVisualizations_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarId",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "focusMinutes",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "busyMinutes",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalMinutes",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "calendarId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "rangeMax"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "rangeMin"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "timeZone"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "ProfileTimeVisualizations_org",
        "selections": [
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "calendarId",
                        "variableName": "calendarId"
                    },
                    {
                        "kind": "Variable",
                        "name": "rangeMax",
                        "variableName": "rangeMax"
                    },
                    {
                        "kind": "Variable",
                        "name": "rangeMin",
                        "variableName": "rangeMin"
                    },
                    {
                        "kind": "Variable",
                        "name": "timeZone",
                        "variableName": "timeZone"
                    }
                ],
                "concreteType": "CalendarTimeStats",
                "kind": "LinkedField",
                "name": "calendarTimeStats",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    (v2 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fragmentedMinutes",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unclassifiedMinutes",
                        "storageKey": null
                    },
                    (v3 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CalendarFocusTimeScore",
                        "kind": "LinkedField",
                        "name": "scoresByDay",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "secondaryKey",
                                "storageKey": null
                            },
                            (v2 /*: any*/),
                            (v1 /*: any*/),
                            (v3 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UserWorkingHours",
                "kind": "LinkedField",
                "name": "userWorkingHours",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkingHours",
                        "kind": "LinkedField",
                        "name": "workingHours",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DaySetting",
                                "kind": "LinkedField",
                                "name": "daySettings",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "day",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '87ed277eeef4d2d4193ca47afae89275';
export default node;
